import gsap from 'gsap';

const modalFunc = () => {
  const modal = document.querySelector('.modal-wrapper');
  if (!modal) return;

  const modalBackdrop = modal.querySelector('.modal-backdrop');
  const modalInner = modal.querySelector('.modal-inner');
  const modalContent = modal.querySelector('.modal-content');
  const modalClose = modal.querySelector('.modal-close');
  const modalTriggers = document.querySelectorAll('.modal-trigger');

  if (!modalTriggers.length || !modalContent) return;

  let activeSource = null;
  let isAnimating = false;
  let activeTimeline = null;

  const setClosedState = () => {
    gsap.set(modalBackdrop, { opacity: 0 });
    gsap.set(modalInner, { opacity: 0, y: 24, xPercent: -50, yPercent: -50 });
  };

  setClosedState();

  const moveContentToModal = (source) => {
    while (source.firstChild) {
      modalContent.appendChild(source.firstChild);
    }
    activeSource = source;
  };

  const restoreContent = () => {
    if (!activeSource) return;

    while (modalContent.firstChild) {
      activeSource.appendChild(modalContent.firstChild);
    }

    activeSource = null;
  };

  const finishClose = () => {
    restoreContent();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    setClosedState();

    if (window.lenis) {
      window.lenis.start();
    }

    isAnimating = false;
  };

  const openModal = (source) => {
    if (isAnimating || activeSource) return;

    isAnimating = true;
    moveContentToModal(source);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');

    if (window.lenis) {
      window.lenis.stop();
    }

    activeTimeline?.kill();
    activeTimeline = gsap.timeline({
      onComplete: () => {
        isAnimating = false;
      },
    });

    activeTimeline
      .to(modalBackdrop, {
        opacity: 1,
        duration: 0.45,
        ease: 'power2.out',
      })
      .to(
        modalInner,
        {
          opacity: 1,
          y: 0,
          xPercent: -50,
					yPercent: -50,
          duration: 0.5,
          ease: 'power3.out',
        },
        '-=0.3'
      );
  };

  const closeModal = () => {
    if (!activeSource || isAnimating) return;

    isAnimating = true;
    activeTimeline?.kill();

    activeTimeline = gsap.timeline({
      onComplete: finishClose,
    });

    activeTimeline
      .to(modalInner, {
        opacity: 0,
        y: 16,
        xPercent: -50,
				yPercent: -50,
        duration: 0.35,
        ease: 'power2.inOut',
      })
      .to(
        modalBackdrop,
        {
          opacity: 0,
          duration: 0.3,
          ease: 'power2.inOut',
        },
        '-=0.2'
      );
  };

  modalTriggers.forEach((trigger) => {
    const popup = trigger.querySelector('.modal-popup');

    if (!popup) return;

    trigger.addEventListener('click', (event) => {
      if (trigger.tagName === 'A' || trigger.tagName === 'BUTTON') {
        event.preventDefault();
      }

      openModal(popup);
    });
  });

  modalClose?.addEventListener('click', (event) => {
    event.preventDefault();
    closeModal();
  });

  modalBackdrop?.addEventListener('click', () => {
    closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeSource) {
      closeModal();
    }
  });
};

export { modalFunc };
